<template>
    <div class="ph-container">
         <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item style="margin-top: 20px;">文档管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
        <!-- <el-form-item label="搜索："></el-form-item> -->
        <el-form-item>
            会员名称：
            <el-select size="small" v-model="formInline.uid" style="width:240px" filterable placeholder="请选择">
            <el-option v-for="type in userArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus"  @click="handleEdit()">添加</el-button>
        </el-form-item>
        </el-form>
        <el-table size="small" @selection-change="selectChange" :data="documentData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column align="center" type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column prop="uid" v-if="idShow">
            </el-table-column>
            <!-- <el-table-column align="center" prop="deptName" label="公司" width="120">
            </el-table-column> -->
            <el-table-column align="center" prop="name" label="文档名称">
            </el-table-column>
            <el-table-column align="center" prop="category" label="分类">
            </el-table-column>
            <el-table-column align="center" prop="type" label="文档类型">
            </el-table-column>
            <el-table-column align="center" prop="url" label="文档地址">
            </el-table-column>
            <el-table-column align="center" prop="add_time" label="添加时间">
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="120">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑文档</el-button>
                    <el-button size="mini" type="danger">删除文档</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog('editForm')">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="会员名称" prop="uid">
                    <el-select size="small" v-model="editForm.uid" filterable placeholder="请选择">
                    <el-option v-for="type in userArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="文档名称" prop="name">
                <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="输入文档名称"></el-input>
                </el-form-item>
                <el-form-item label="文档分类" prop="category">
                <el-input size="small" v-model="editForm.category" auto-complete="off" placeholder="输入文档分类"></el-input>
                </el-form-item>
                <el-form-item label="文档类型" prop="type">
                <el-input size="small" v-model="editForm.type" auto-complete="off" placeholder="输入文档分类"></el-input>
                </el-form-item>
                <el-form-item label="文档地址" prop="url">
                    <el-input size="small" v-model="editForm.url" auto-complete="off" placeholder="输入文档地址">
                        <el-upload
                            class="avatar-uploader"
                            :action= uploadUrl
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload"
                            slot="append">
                            上传
                        </el-upload>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    getSelectUserList,
    webUrl,
    getAdminDocumentList,
    editAdminDocument,
    delAdminDocument
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
    data() {
        return {
            loading: false, //是显示加载
            idShow: false, //列表uid不显示
            editFormVisible: false, //详情界面是否显示
            title: '',
            // 会员下拉框数据
            userArr: [],
            formInline: {
                uid: '',
                page: 1,
                ps: 10,
            },
            editForm: {
                id: '',
                uid: '',
                category: '',
                name: '',
                url: '',
                type: ''
            },
            documentData: [],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            // 文件上传接口地址
            uploadUrl: webUrl+'/patent/tool/uploadAdminDocument',
 
            // rules 表单验证
            rules: {
                name: [
                { required: true, message: '请输入文档名称', trigger: 'blur' }
                ],
                type: [
                { required: true, message: '请输入文档类型', trigger: 'blur' }
                ],
                category: [
                { required: true, message: '请输入文档分类', trigger: 'blur' }
                ],
                url: [
                { required: true, message: '请输入文档地址', trigger: 'blur' }
                ],
                uid: [
                { required: true, message: '请选择会员账户', trigger: 'blur' }
                ],
            },
        }
    },
        // 注册组件
    components: {
        Pagination
    },
        /**
 * 数据发生改变
 */
watch: {},

/**
 * 创建完毕
 */
created() {
// this.getdata(this.formInline)
// this.getRole()
    this.getUserSelectArr()
},
/**
 * 里面的方法只有被调用才会执行
 */
methods: {
    // 查询会员下拉框数据
    getUserSelectArr() {
        let param = {}
        getSelectUserList(param)
        .then(res=>{
            if(res.code == 200){
            this.userArr = res.data
            }
        })
    },
    getdata(param){
        if(param.uid.length <= 0){
            this.$message({
                type: 'info',
                message: '请选择需要查询的会员账户!'
            })
            return false
        }
        getAdminDocumentList(param)
        .then(res=>{
            if(res.code == 200){
                this.documentData = res.data.dataList
                // 分页赋值
                this.pageparm.currentPage = this.formInline.page
                this.pageparm.pageSize = this.formInline.ps
                this.pageparm.total = res.data.total
            }else{
                this.$message({
                    type: 'info',
                    message: res.msg
                })
            }
        })
    },
    // 查询文档列表
    search(){
        this.getdata(this.formInline)
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    closeDialog(title){
        if(title == 'editForm'){
            this.editFormVisible = false
        }
    },
    handleEdit(index,row){
        if(row){
            this.title = '编辑文档'
            this.editForm.id = row.id
            this.editForm.uid = row.uid
            this.editForm.name = row.name
            this.editForm.category = row.category
            this.editForm.type = row.type
            this.editForm.url = row.url
            this.editFormVisible = true
        }else{
            this.title = '添加文档'
            this.editForm.id = ''
            this.editForm.uid = ''
            this.editForm.name = ''
            this.editForm.category = ''
            this.editForm.type = ''
            this.editForm.url = ''
            this.editFormVisible = true
        }
    },
    // 提交保存
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          editAdminDocument(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                 this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
        } else {
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.ps = parm.pageSize
        this.getdata(this.formInline)
    },

    // 图片上传相关
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
          // this.imageUrl = res.data.url;
          this.editForm.url = res.data.save_url
          this.editForm.name = res.data.name
          this.editForm.type = res.data.type
      }else{
          this.$message({
              type: 'error',
              message: res.msg
            })
      }
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
      },
}

}
</script>
<style scoped>
.user-search {
margin-top: 20px;
}
.userRole {
width: 100%;
}
.ph-container {
margin: 0 auto;
max-width: 1680px;
min-width: 1024px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/Document.vue